export class DeclaracaoRda {

  rda: number;
  empresaDevidamenteInscrita: boolean;
  empresaOptouSimplificado: boolean;
  empresaDeclaraRegularidade: boolean;
  empresaDeclaraAtualizado: boolean;
  empresaDeclaraImplantadoCertificacao: boolean;
  empresaDeclaraImplantadoPrograma: boolean;
  empresaDeclaraInformacoesFiscais: boolean;
  empresaDeclaraInformacoesApresentadas: boolean;
  empresaResponsabiliza: boolean;
  observacao: string;


  constructor(init?: Partial<DeclaracaoRda>) {
    Object.assign(this, init);
  }

}
